import PropTypes from 'prop-types'
import React from 'react'
import { Field } from 'redux-form'
import styles from './_errorField.css'
import classnames from 'classnames'
import fieldProps from './fieldProps'
import FieldError from './FieldError'

export function ErrorField (props) {
  const {
    slim,
    disabled,
    errorComponent,
    meta: {
      touched,
      error,
    },
  } = props

  const showError = Boolean(touched && error)
  const className = classnames(styles.container, props.className, styles.errorField, {
    [styles.disabled]: disabled,
    [styles.slim]: slim,
    [styles.showError]: showError,
  })

  return (
    <div className={className}>
      <FieldError
        className={styles.errorMessage}
        errorComponent={errorComponent}
        showError={showError}
        errorMessage={error}
      />
    </div>
  )
}

ErrorField.propTypes = fieldProps

export const renderField = (field) => <ErrorField {...field} />
export const FieldWrapper = (props) => <Field {...props} component={renderField} />

FieldWrapper.propTypes = {
  errorComponent: PropTypes.node,
}

export default FieldWrapper



// WEBPACK FOOTER //
// ./src/components/forms/ErrorField.jsx